import {pluralize} from 'lib/stringUtils';

import {baseGuideLevelExtensions} from '../guideLevelHelpers/baseGuideLevel.extensions';

export const extensions = {
  ...baseGuideLevelExtensions,

  getLinkToQuestions() {
    return `/learn/${this.getSubject().getUrlSlug()}/${this.getUrlSlug()}`;
  },

  getQuestionMetadataForSubjectView(hasTeacherAccess = false) {
    const questions = this.getMeta().getCountOfQuestions();
    const questionsAnswered = this.getMeta().getStudentCountOfUniqueGuesses();
    if (hasTeacherAccess || !questionsAnswered) {
      return `${questions} ${pluralize('question', questions)}`;
    }
    return `${questionsAnswered}/${questions} ${pluralize('question', questions)}`;
  }
};
